import { render } from "./OverheaderComp.vue?vue&type=template&id=46c003a8&scoped=true&ts=true"
import script from "./OverheaderComp.vue?vue&type=script&lang=ts"
export * from "./OverheaderComp.vue?vue&type=script&lang=ts"

import "./OverheaderComp.vue?vue&type=style&index=0&id=46c003a8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c003a8"]])

export default __exports__